import { AddBox, MailOutline, Phone } from "@mui/icons-material";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import React from "react";
import { ROUTES } from "../Routes";

export default function AppFooter(props) {
  return (
    <>
      <BottomNavigation showLabels style={{ marginTop: "30px" }}>
        <BottomNavigationAction
          label="info@jojoo.se"
          icon={<MailOutline />}
          onClick={() => window.open("mailto:info@jojoo.se")}
        />
        <BottomNavigationAction
          onClick={() => {
            window.location = ROUTES.MY_JOB_REQUESTS + "?createNewAd";
          }}
          label="Lägg in Annons"
          icon={<AddBox />}
        />
        <BottomNavigationAction
          label="08-366224"
          icon={<Phone onClick={() => window.open("tel:08366224")} />}
        />
      </BottomNavigation>
    </>
  );
}
